import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    .ExpansionIndicator-Content {\n        background-color: ", ";\n        width: 40px;\n    }\n    .ExpansionIndicator-Icon {\n        color: ", ";\n    }\n\n    ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    opacity: 0;\n    z-index: 2048;\n\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            transition: all ", "s ease;\n            opacity: 1;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { ExpansionIndicator } from '../../ExpansionIndicator';
import { transitionDurationInSec } from '../../../constants';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
import { color } from '../../../system/mixins';
import { getPropsBlocker } from '../../../utils';
export var HeaderNavigationMenuRoot = styled.div(_templateObject());

var contentContainerStyle = function contentContainerStyle(_ref) {
  var isExpanded = _ref.isExpanded,
      HeaderNavigationMenu = _ref.theme.componentOverrides.HeaderNavigationMenu;
  var result = HeaderNavigationMenu.ContentContainer.base;

  if (isExpanded) {
    result = css(_templateObject2(), result, transitionDurationInSec);
  }

  return result;
};

export var HeaderNavigationMenuContentContainer = styled.div.withConfig(getPropsBlocker())(_templateObject3(), contentContainerStyle);

var expansionIndicatorItemStyle = function expansionIndicatorItemStyle(_ref2) {
  var HeaderNavigationMenu = _ref2.theme.componentOverrides.HeaderNavigationMenu;
  return HeaderNavigationMenu.ExpansionIndicatorItem.base;
};

export var MenuExpansionIndicatorItem = styled.div.withConfig(getPropsBlocker())(_templateObject4(), expansionIndicatorItemStyle);
export var HeaderNavigationMenuTitleContainer = styled.div.withConfig(getPropsBlocker())(_templateObject5());
export var HeaderNavigationMenuTitle = styled.div.withConfig(getPropsBlocker())(_templateObject6());
export var MenuExpansionIndicator = styled(ExpansionIndicator).withConfig(getPropsBlocker({}, false))(_templateObject7(), color('neutral.02'), color('neutral.06'), getComponentOverride('HeaderNavigationMenu'));